import { get } from 'lodash';
import { useFormState } from 'react-hook-form';
import { FormField, FormFieldProps } from 'ui/formField';
import {
  FrequencyManagementSchema,
  SchemaFormKeys,
} from 'modules/frequencyManagement/contexts/FormProvider';

type Props = {
  name: SchemaFormKeys;
  children: React.ReactNode;
} & FormFieldProps;

export const ConnectedFormField = ({ labelText, name, children, ...rest }: Props) => {
  const { errors } = useFormState<FrequencyManagementSchema>({ name });
  const { message } = get(errors, name, { message: '' });

  return (
    <FormField
      {...rest}
      labelText={labelText}
      inputId={name}
      errorText={message}
      hasError={Boolean(message)}
    >
      {children}
    </FormField>
  );
};
